import React from "react"
import Background from "./Background"
import styled from "styled-components"
import { Link } from "gatsby"
import { Breadcrumb } from "semantic-ui-react"

const PagesHero = ({
  image,
  icon,
  title,
  parag,
  paragraph2,
  link,
  activeLink,
  className,
  lang,
}) => {
  const healthSection = title === "قطاع الصحة" ? true : false

  return (
    <Wraper healthSection={healthSection}>
      <Background image={image}>
        <div className="container">
          <div className="content">
            {icon && <img src={icon} alt="icon" />}
            <h3 className="font">{title}</h3>
            <p>{parag}</p>
            <p className="textParg">{paragraph2}</p>
            <div className={className}></div>
            <div className="breadC">
              <Breadcrumb>
                <Breadcrumb.Section active style={{ marginRight: "10px" }}>
                  {activeLink}
                </Breadcrumb.Section>
                {link && (
                  <>
                    <Breadcrumb.Divider
                      icon={`arrow  ${lang === "ar" ? "left" : "right"} `}
                    />
                    <Breadcrumb.Section link>{link} </Breadcrumb.Section>
                  </>
                )}
                <Breadcrumb.Divider
                  icon={`chevron ${lang === "ar" ? "left" : "right"}`}
                />
                <Breadcrumb.Section link>
                  <Link to={lang === "ar" ? "/" : "/" + lang + "/"}>
                    {lang === "ar"
                      ? "الرئيسية"
                      : lang === "en"
                      ? "Home"
                      : "Ana sayfa"}
                  </Link>
                </Breadcrumb.Section>
              </Breadcrumb>
            </div>
          </div>
        </div>
      </Background>
    </Wraper>
  )
}

export default PagesHero

const Wraper = styled.section`
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;
    padding: 30px 0 10px 0;
    img {
      width: 75px;
    }
    h3 {
      margin: 5px 0 10px 0;
      color: ${props => props.theme.lg};
    }
  }
  p {
    margin: 0;
    font-size: 1.1rem;
  }
  .textParg {
    padding: ${props => props.parojectsPage && "2% 0"};
  }
  .breadC {
    padding-top: ${props => !props.healthSection && "2%"};

    a {
      color: white !important;
      font-size: 1rem;
      &:hover {
        color: ${props => props.theme.lg} !important;
      }
    }
  }
  @media screen and (max-width: 800px) {
    p {
      font-size: 1rem;
    }
  }
  @media screen and (max-width: 500px) {
    .breadC {
      display: none;
    }
  }
`
